import React from "react";
import "./StatsSection.css";
import { useTranslation } from "react-i18next";

export default function StatsSection() {
  const { t } = useTranslation();

  const stats = [
    { value: "98%", label: t("home.stats.satisfactionRate") },
    { value: "10K+", label: t("home.stats.activeUsers") },
    { value: "5K+", label: t("home.stats.jobsMatched") },
    { value: "4.9/5", label: t("home.stats.averageRating") },
  ];

  return (
    <section
      className="stats-section"
      role="region"
      aria-label={t("home.stats.ariaLabel", "Platform statistics")}
    >
      <div className="stats-inner">
        {stats.map((stat, i) => (
          <div className="stat-item" key={i}>
            <div className="stat-value">{stat.value}</div>
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
